<template>
  <page-toolbar v-if="activeTab" :searchable="false">
    <template #filters>
      <v-col cols="auto" v-if="activeTab.filters.warehouse">
        <autocomplete
          :label="$t('stock')"
          :items="warehouses"
          :value="selectedWarehouses"
          @input="$emit('update:selectedWarehouses', $event)"
          return-object
          clearable
          chips
          selectable-all
          small-chips
          deletable-chips
          hide-details
          prepend-item
          multiple
          item-text="name"
          item-value="id"
          color="white"
        >
          <template v-slot:prepend-item>
            <v-list-item @click="$emit('toggle-warehouses')">
              <v-list-item-icon>
                <v-icon>mdi-select-all</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t("display_all") }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </autocomplete>
      </v-col>

      <v-col cols="auto" v-if="activeTab.filters.show_type">
        <dropdown
          :label="$t('view')"
          :items="showItems"
          :value="filters.showType"
          @input="updateFilter('showType', $event)"
          :disabled="!filters.warehouse.length"
          hide-details
          color="white"
          style="max-width: 250px"
        />
      </v-col>

      <v-col cols="auto" v-if="activeTab.filters.shifts">
        <shift-picker v-model="filters.selectedShifts" multiple color="white" />
      </v-col>

      <v-col cols="auto" v-if="activeTab.filters.date_from">
        <date-picker
          :value="
            activeTab.filters.date_to
              ? [filters.dates.from, filters.dates.to]
              : filters.dates.from
          "
          @input="handleDateUpdate"
          :single-date="!activeTab.filters.date_to"
          :readonly="activeTab.filters.date_from_readonly"
          color="white"
        />
      </v-col>

      <v-col cols="auto" v-if="activeTab.filters.show_order">
        <dropdown
          :label="$t('warehouse.document_type')"
          :items="documentTypeItems"
          :value="filters.documentType"
          @input="updateFilter('documentType', $event)"
          item-text="name"
          item-value="value"
          hide-details
          color="white"
        />
      </v-col>

      <v-col cols="auto" v-if="activeTab.filters.state_filter">
        <dropdown
          :label="$t('status')"
          :items="statusTypes"
          :value="filters.status"
          @input="updateFilter('status', $event)"
          item-text="name"
          item-value="value"
          hide-details
          color="white"
        />
      </v-col>

      <v-col cols="auto" v-if="activeTab.filters.type_filter">
        <dropdown
          :label="$t('warehouse.document_type')"
          :items="transactionTypes"
          :value="filters.documentType"
          @input="updateFilter('documentType', $event)"
          item-text="text"
          item-value="value"
          hide-details
          color="white"
        />
      </v-col>

      <v-col cols="auto" v-if="activeTab.filters.offer_type_filter">
        <dropdown
          :label="$t('warehouse.document_type')"
          :items="offerTypeItems"
          :value="filters.documentType"
          @input="updateFilter('documentType', $event)"
          item-text="name"
          item-value="value"
          hide-details
          color="white"
        />
      </v-col>

      <v-col cols="auto" v-if="activeTab.filters.code_filter">
        <grocery-picker
          :value="filters.groceryCode"
          @input="updateFilter('groceryCode', $event)"
          :groceries="codeFilterGroceries"
          hide-details
          color="white"
        />
      </v-col>

      <v-col cols="auto" v-if="activeTab.filters.suppliers">
        <autocomplete
          :label="$t('supplier')"
          :items="suppliers"
          :value="selectedSuppliers"
          @input="$emit('update:selectedSuppliers', $event)"
          return-object
          clearable
          chips
          selectable-all
          small-chips
          deletable-chips
          hide-details
          prepend-item
          multiple
          item-text="name"
          item-value="id"
          color="white"
        >
          <template v-slot:prepend-item>
            <v-list-item @click="$emit('toggle-suppliers')">
              <v-list-item-icon>
                <v-icon>mdi-select-all</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t("display_all") }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </autocomplete>
      </v-col>
      <v-col cols="auto">
        <text-field
          :label="$t('search')"
          :value="filters.search"
          @input="updateFilter('search', $event)"
          append-icon="mdi-magnify"
          hide-details
          color="white"
        />
      </v-col>
      <v-col cols="auto">
        <circle-button
          icon="mdi-refresh"
          :tooltip="$t('refresh')"
          color="primary"
          @click="$emit('refresh')"
        />
      </v-col>
    </template>
  </page-toolbar>
</template>

<script>
import PageToolbar from "@/components/global/PageToolbar.vue";
import GroceryPicker from "@/components/groceries/fields/GroceryPicker.vue";
import warehouseFiltersMixin from "@/mixins/warehouse/warehouseFiltersMixin";

export default {
  name: "WarehouseFiltersDesktop",
  components: {
    PageToolbar,
    GroceryPicker,
  },
  mixins: [warehouseFiltersMixin],
  props: {
    activeTab: {
      type: Object,
      default: null,
    },
    warehouses: {
      type: Array,
      default: () => [],
    },
    selectedWarehouses: {
      type: Array,
      default: () => [],
    },
    selectedSuppliers: {
      type: Array,
      default: () => [],
    },
    suppliers: {
      type: Array,
      default: () => [],
    },
    filters: {
      type: Object,
      required: true,
    },
    codeFilterGroceries: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleDateUpdate(value) {
      // Single date mode - commit with from = to
      if (this.activeTab.filters.date_from && !this.activeTab.filters.date_to) {
        this.$store.commit("warehouse/SET_DATE", [value, value]);
      } else {
        // Date range mode - commit with from/to
        this.$store.commit("warehouse/SET_DATE", value);
      }
    },
  },
};
</script>
